'use client';

type T_AnalyticsParams = Record<
  string,
  string | number | boolean | null | undefined
>;

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window {
    gtag?: (
      command: 'event',
      eventName: string,
      params?: T_AnalyticsParams
    ) => void;
  }
}

export function trackAnalyticsEvent(
  eventName: string,
  params?: T_AnalyticsParams
) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', eventName, params);
}
